export default "__VITE_ASSET__Bj885myt__"